import { filter, get } from "lodash";

export const getHighlightedTags = (
  tags,
  tagConfig,
  flagType = "isPersonBadge"
) => filter(tags, (tag) => get(tagConfig, `${[tag?.type]}.${flagType}`));
